import {useAsyncState} from 'common/hooks/useAsyncState';
import ApiService from 'api/ApiService';
import React from 'react';
import {useHandleApiError} from './useHandleApiError';
import {downloadFile} from 'common/downloadFile';
import {useOpenAlertDialog} from './useOpenAlertDialog';
import {useTranslation} from 'react-i18next';
import {getFileName} from 'api/helpers';

type CallbackOptions = {
   onSuccess?: () => void;
   onFailure?: (error: any, message: string) => void;
};

export function useDownloadPostApi() {
   const {t} = useTranslation();
   const {state, loading, error, setState, setLoading, setError} = useAsyncState<Blob>();
   const handleError = useHandleApiError({setError, setLoading});
   // const {addToast} = useToasts();
   const openDialog = useOpenAlertDialog();

   const download = React.useCallback(
      async (url: string, body?: BodyInit | null, options?: CallbackOptions) => {
         setLoading(true);
         // !options?.persistState && setState(undefined);
         try {
            const res = await ApiService.postSecureJson(url, body!);
            const blob = await res.blob();
            setState(blob);
            options?.onSuccess?.();
            setLoading(false);
            const fileName = getFileName(res);
            if (res.status === 204) {
               openDialog({content: t('No records found.'), title: res.statusText});
            } else {
               downloadFile(blob, fileName!);
            }
         } catch (e) {
            handleError(undefined, url)(e as Response);
            options?.onFailure?.(e, (e as Error).message);
         }
      },
      [handleError, setLoading, setState]
   );
   return {download, state, loading, error};
}
